/**
 * @returns A trimmed non-empty value.  If the trimmed value is empty, undefined is returned
 */
function nonEmptyOrUndefined(input) {
  if (input && input.trim().length) {
    return input.trim();
  }
  return undefined;
}

export { nonEmptyOrUndefined };
